import FlashLib from "flashlib";
import LocalizationManager from "Engine/base/localization/LocalizationManager";
import RelaxModel from "Base/model/RelaxModel";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class TopMessageContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
    }

    init() {
        this.valueText = this.getChildByName('valueText');
        this.valueText.text = LocalizationManager.getLocalizedText('label_for_fun');
        //this.valueText.text = RelaxModel.moneyMode === 'fun' ? LocalizationManager.getLocalizedText('label_for_fun') : '';
        this.visible =  RelaxModel.moneyMode === 'fun';
    }

    addListeners() {
        GlobalDispatcher.add('topMessageContainer:setText', this.setText, this);
    }

    setText(data) {
        if (data.params) {
            this.valueText.text = LocalizationManager.getLocalizedText(data.params.message, data.params.params);
            this.visible = true;
        } else {
            this.valueText.text = LocalizationManager.getLocalizedText('label_for_fun');
            this.visible =  RelaxModel.moneyMode === 'fun';
        }
    }
}